<template>
  <div class="create-package bg-white">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">{{ isEditMode ? 'Edit' : 'Buat' }} Layanan</p>
        <div class="mb-6">
          <TextField type="text" label="Nama Layanan" v-model="name" placeholder="Masukan nama layanan" />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Kode Layanan (Sistem saat ini)" v-model="serviceCode" placeholder="Masukan kode layanan" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Deskripsi</label>
          <quill-editor ref="myQuillEditor1" v-model="description" :options="option" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tipe Layanan</label>
          <CustomSelect :options="deliveryServiceTypeList" v-model="deliveryServiceType" :default="deliveryServiceType" placeholder="Pilih tipe layanan" optionLabel="name" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kategori Layanan</label>
          <CustomSelect :options="serviceCategory" v-model="selectedServiceCategory" :default="selectedServiceCategory" placeholder="Pilih kategori layanan" optionLabel="name" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Cost Mapping</label>
          <CustomSelect :options="costMapping" v-model="selectedCostMapping" :default="selectedCostMapping" placeholder="Pilih cost mapping" optionLabel="name" enableSearch @search="doSearch" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Syarat & Ketentuan</label>
          <quill-editor ref="myQuillEditor2" v-model="termAndCondition" :options="option" />
        </div>
      </div>
      <div class="flex-1 mdmax:flex-auto mdmax:w-full">
        <div class="p-6">
          <div class="mb-6">
            <p class="font-bold text-lg mb-6">Kategori Barang</p>
            <div class="mb-3" v-for="(goods, index) in goodsCategories" :key="'goods' + index">
              <input type="checkbox" class="styled-checkbox" name="goodsCategory" :id="goods.code" :value="goods.code" v-model="selectedGoodsCategories" />
              <label :for="goods.code">{{ goods.name }}</label>
            </div>
          </div>

          <p class="font-bold text-lg mb-6">Status Layanan</p>
          <div class="flex items-center gap-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 block">Status</label>
            <label class="relative inline-block h-4 leading-0">
              <input v-model="status" type="checkbox" class="w-10 h-4 transition bg-gray-300 rounded-full shadow-inner outline-none appearance-none checked:bg-blue-500 disabled:bg-gray-100" />
              <span class="absolute top-0 left-0 w-4 h-4 transition-all transform scale-150 bg-system-gray rounded-full shadow-sm cursor-pointer"></span>
            </label>
            <p :class="[status ? 'text-system-success' : 'text-system-error']">{{ status ? 'Active' : 'In Active' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end gap-6 p-6">
      <Button :buttonText="isEditMode ? 'Update' : 'Simpan'" type="primary" @action="save()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    // LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    quillEditor
  },
  data: () => ({
    option: {
      modules: {
        toolbar: [['bold', 'italic', 'underline', 'strike'], [{ list: 'ordered' }, { list: 'bullet' }], [{ size: ['small', false, 'large', 'huge'] }], ['clean']]
      }
    },
    serviceCategory: [
      {
        name: 'Regular (Reg)',
        value: 'REG'
      },
      {
        name: 'Satu Harga (One)',
        value: 'ONE'
      }
    ],
    selectedServiceCategory: null,
    name: '',
    termAndCondition: '',
    serviceCode: '',
    deliveryServiceTypeList: [
      {
        name: 'Pickup and Dropoff',
        value: 'A'
      },
      {
        name: 'Pickup Only',
        value: 'P'
      },
      {
        name: 'Dropoff Only',
        value: 'D'
      }
    ],
    deliveryServiceType: '',
    selectedCostMapping: '',
    selectedGoodsCategories: [],
    status: false,
    description: '',
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 100,
    hasMorePages: true
  }),
  computed: {
    ...mapGetters('master', ['goodsCategories']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('partner', ['costMapping', 'packageDetail']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    packageId() {
      return this.$route.params.id
    },
    isEditMode() {
      return this.packageId !== undefined
    }
  },
  methods: {
    ...mapActions('master', ['getGoodsCategories']),
    ...mapActions('partner', ['createPackage', 'updatePackage', 'getCostMapping', 'getPackageDetail']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getPackageInfo() {
      this.showLoading()
      const partnerId = this.userData?.user?.group_id
      this.getPackageDetail({
        partnerId: partnerId,
        packageId: this.packageId
      }).then(res => {
        this.hideLoading()
        this.distributePayloads(res.data.data)
      })
    },
    distributePayloads(res) {
      this.name = res.name
      this.description = res.description
      this.deliveryServiceType = this.deliveryServiceTypeList.filter(item => item.value === res.delivery_service_type)[0]
      this.selectedServiceCategory = this.serviceCategory.filter(item => item.value === res.delivery_service_category)[0]
      this.selectedCostMapping = res.cost_mapping_id ? this.costMapping.filter(item => item.id === res.cost_mapping_id)[0] : ''
      this.termAndCondition = res.tnc
      this.serviceCode = res.package_external_code
      if (res.package_goods_categories && res.package_goods_categories.length > 0) {
        res.package_goods_categories.forEach(item => {
          this.selectedGoodsCategories.push(item.category_id)
        })
      }
      this.status = res.status === 'ACTIVE'
    },
    doSearch(searchTerm) {
      this.getCostMappingList(searchTerm)
    },
    getCostMappingList(searchTerm = '') {
      this.showLoading()
      this.getCostMapping({
        partnerId: this.partnerId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      }).then(res => {
        this.hideLoading()
        if (this.isEditMode) {
          this.getPackageInfo()
        }
      })
    },
    getGoodsCategoryList() {
      this.showLoading()
      this.getGoodsCategories({
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: '',
          sort: 'DESC'
        }
      })
        .then(() => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    save() {
      this.showLoading()
      const partnerId = this.userData?.user?.group_id
      const payloads = {
        name: this.name,
        description: this.description,
        tnc: this.termAndCondition,
        status: this.status ? 'ACTIVE' : 'INACTIVE',
        delivery_service_type: this.deliveryServiceType.value,
        delivery_service_category: this.selectedServiceCategory.value,
        cost_mapping_id: this.selectedCostMapping && this.selectedCostMapping.id,
        goods_categories: this.selectedGoodsCategories,
        package_external_code: this.serviceCode
      }
      if (this.isEditMode) {
        this.updatePackage({
          partnerId: partnerId,
          packageId: this.packageId,
          payloads: payloads
        }).then(res => {
          this.hideLoading()
          this.$router.push('/package')
        })
      } else {
        this.createPackage({
          id: partnerId,
          payloads: payloads
        }).then(res => {
          this.hideLoading()
          this.$router.push('/package')
        })
      }
    }
  },
  async created() {
    await this.getGoodsCategoryList()
    await this.getCostMappingList()
  }
}
</script>
<style lang="scss" scoped>
.create-package {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 16px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
  &::v-deep .vs__dropdown-toggle {
    padding: 0;
    border-radius: 0.5rem;
  }
}
.styled-checkbox {
  position: absolute; // take it out of document flow
  opacity: 0; // hide it

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
  }

  // Box.
  & + label:before {
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: white;
    border: 1px solid #2e9c95;
    border-radius: 4px;
  }

  // Box hover
  &:hover + label:before {
    background: #2e9c95;
  }

  // Box focus
  &:focus + label:before {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
  }

  // Box checked
  &:checked + label:before {
    background: #2e9c95;
  }

  // Disabled state label.
  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  // Disabled box.
  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  // Checkmark. Could be replaced with an image
  &:checked + label:after {
    content: '';
    position: absolute;
    left: 5px;
    top: 9px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
    transform: rotate(45deg);
  }
}
input:checked[type='checkbox'] + span {
  left: 1.5rem;
  top: 0;
  background-color: #f2994a;
}
input:checked[type='checkbox']:disabled {
  background-color: rgba(25, 21, 255, 0.5);
}
input:checked[type='checkbox']:disabled + span {
  background-color: rgb(93, 91, 233);
  box-shadow: none;
}
input[type='checkbox']:disabled + span {
  background-color: rgb(214, 211, 211);
  box-shadow: none;
}
</style>
